import React from 'react'
import styles from './Global.module.css'

function Loading() {
  return (
    <span className={`${styles.loader} ${styles.loader_sm}`}> </span>
  )
}

export default Loading